var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radio-btn radio-btn-single" }, [
    _c("label", { staticClass: "radio-btn__label" }, [
      _c("input", {
        attrs: { type: "radio", name: _vm.item.name },
        domProps: {
          value: _vm.item.value,
          checked: _vm.item.value === _vm.value
        },
        on: { change: _vm.onChange }
      }),
      _c("span", { staticClass: "radio-btn__span" }),
      _c("span", { staticClass: "radio-btn__name" }, [
        _vm._v("\n      " + _vm._s(_vm.item.label) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51a5bfab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a5bfab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseRadioSingle.vue
// module id = lOUs
// module chunks = 13